import React from 'react';
import styled from 'styled-components';

export const labelAlignConst = { start: 'start', center: 'center', end: 'end' };
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  column-gap: 8px;
  > :nth-child(1) {
    align-self: ${(props) => (props.labelAlign ? props.labelAlign : 'center')};
  }
`;

const LabelText = styled.div`
  /* width: 96px; */
  width: ${(props) => (props.labelWidth ? props.labelWidth : 96)}px;
  font-size: 12px;
  color: ${(props) => props.theme.color.BLACK};
  ${({ required, theme }) =>
    required &&
    `
    &:after {
      content: ' *';
      display: inline;
      color: ${theme.color.RED_70};
    }
  `}
`;

const InputContainer = styled.div`
  width: 254px;
`;

function DialogRowItem(props) {
  return (
    <Wrapper labelAlign={props.labelAlign}>
      <LabelText labelWidth={props.labelWidth} required={props.required}>
        {props.label}
      </LabelText>
      <InputContainer>{props.children}</InputContainer>
    </Wrapper>
  );
}

export default DialogRowItem;
